import {computed, ref} from 'vue'
import {defineStore} from 'pinia'
import qs from 'qs'
import axios from 'axios'

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

axios.defaults.baseURL = import.meta.env.VITE_APP_MIDDLEWARE
export const useQuestionStore = defineStore('question', () => {
  const index = ref(0)
  const step = ref('start') //start, question, crmform, result
  const questions = ref([])
  const results = ref({})
  const centers = ref([])
  const knowStudy = ref(false)


  const selectedQuestion = computed(() => {
    return questions.value[index.value]
  })

  const questionsResult = computed(() => {
    let keys = Object.keys(results.value);
    return keys.map(function (key) {
      return Math.pow((results.value[key].resultado / 10), 2.71828182845904);
    })
  })

  const areas = computed(()=>{
    return Object.keys(results.value).map(function (area) {
      return capitalizeFirstLetter(results.value[area].name)
    })
  })

  const keyFilterArea = computed(() => {
    let keys = Object.keys(results.value);
    let resultados = keys.map(function (area) {
      return  {
        name: results.value[area].name,
        value: results.value[area].resultado
      }
    })

    //devolvemos el máximo resultado
    let maxValue = Math.max.apply(Math, resultados.map(function(o) { return o.value; }))
    let bestArea = resultados.filter(function (x) {
      if(x.value === maxValue)
        return x
    })
    return bestArea[0].name
  })


  const bestResult = computed(() => {
    let keys = Object.keys(results.value);
    let resultados = keys.map(function (area) {
      return  {
        area: results.value[area].name,
        frase: results.value[area].frase,
        value: results.value[area].resultado
      }
    })
    //devolvemos el máximo resultado
    let maxValue = Math.max.apply(Math, resultados.map(function(o) { return o.value; }));
    return resultados.filter(function (x) {
      if(x.value === maxValue)
        return x
    })[0]

  })


  function changeStepWithReset (payload) {
    index.value = 0
    step.value = payload
  }
  function backQuestion () {
    index.value--;
  }

  function saveQuestionAnswer (payload) {
    questions.value[index.value]['contestado'] = payload.answer
    index.value++;
  }

  function calc() {
    let questionsTemp = questions.value;
    Object.keys(results.value).map(function (area) {
      return results.value[area].resultado = 0
    });

    questionsTemp.map(function (q) {
      let respuesta = q['contestado'];
      Object.keys(q['areas']).map(function (key) {
        let questionValue = q['areas'][key];
        if(respuesta !== 0){
          results.value[key].resultado += questionValue*respuesta;
        }
      });
    });
  }

  async function sendForm(form) {

    const cursoActual = import.meta.env.VITE_APP_CURSO_ACADEMICO
    //const cursoReplace = cursoActual.replace('/', '').slice(2)

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    let clidId = null
    let clidSource = null
    if (urlParams.get('gclid')) {
      clidId=urlParams.get('gclid')
      clidSource='google'
    } else if (urlParams.get('fbclid')) {
      clidId=urlParams.get('fbclid')
      clidSource='facebook'
    } else if (urlParams.get('ttclid')) {
      clidId=urlParams.get('ttclid')
      clidSource='tiktok'
    } else if (urlParams.get('li_fat_id')) {
      clidId=urlParams.get('li_fat_id')
      clidSource='linkedin'
    } else if (urlParams.get('twclid')) {
      clidId=urlParams.get('twclid')
      clidSource='twitter'
    } else if (urlParams.get('spcid')) {
      clidId=urlParams.get('spcid')
      clidSource='spotify'
    }

    try{
      const { status, data } = await axios.post('/leads/save',
        qs.stringify( {
          nombre: form.name,
          apellido1: form.lastname,
          apellido2: form.lastname2,
          email: form.email,
          pais: "E",
          provincia: form.province,
          prefijoTel: "34",
          telefono: form.tlf,
          canalContactoPreferido: form.contactCanal,
          recibirComunicacionesComerciales: form.comercial,
          comercialLearning: knowStudy.value? form.study : 'SinTitulación',
          centroEstudios: form.center,
          campaignType: 'Feria educativa',
          url: location.protocol + '//' + location.host + location.pathname,
          utmCampaign: urlParams.get('utm_campaign'),
          utmSource: urlParams.get('utm_source'),
          utmMedium: knowStudy.value? urlParams.get('utm_medium') : form.bestResult.area.toUpperCase(),
          utmContent: urlParams.get('utm_content'),
          utmTerm: 'TEST_SIE',
          clidId: clidId,
          clidSource: clidSource,
          estudiosProcedencia: form.estudioCursado
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
          },
        }
      )
      if(status === 200){
        if(!knowStudy.value) {
          step.value = 'result'
        }else{
          changeStepWithReset('final')
        }
        console.log('Petición realizada')
      }
    }catch (e) {
      console.log('Petición realizada con fallos.' + e);
    }




    if (!knowStudy.value) {
      step.value = 'result'
    }else{
      changeStepWithReset('final')
    }
  }

  async function loadProvincies() {
    try{
      const { status, data } = await axios.get('/leads/provincias')
      if(status === 200){
        return data
      }
    }catch (e) {
      console.log('Error al cargar los provincias.' + e);
    }
    return []
  }

  async function getCentersByProvince(province){
    try{
      const { data } = await axios.get('/leads/colegios?idProvincia='+province)
      centers.value = data
      console.log('Petición realizada.')
    }catch (e){
      console.log('Petición realizada con fallos.' + e);
    }
  }

  return { index, step, questions, results, centers, knowStudy, selectedQuestion, questionsResult, areas, keyFilterArea, bestResult, changeStepWithReset, backQuestion, saveQuestionAnswer, calc, sendForm, getCentersByProvince, loadProvincies }
})
